import { render, staticRenderFns } from "./SecondLayout.vue?vue&type=template&id=2b3db2fb&scoped=true&"
import script from "./SecondLayout.vue?vue&type=script&lang=js&"
export * from "./SecondLayout.vue?vue&type=script&lang=js&"
import style0 from "./SecondLayout.vue?vue&type=style&index=0&id=2b3db2fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3db2fb",
  null
  
)

export default component.exports